<template>
  <div>
    <div id="PengajuanManagement">
      <div class="row mb-4">
        <div class="col-sm-8">
          <h2>Manajemen Pengajuan Lending</h2>
        </div>
        <div class="col-sm-4 text-right">
          <b-button
            :disabled="isLoading"
            variant="primary"
            class="btn btn-custom theme-color px-4 rounded-5"
            @click="downloadPengajuanMitra"
          >
            <b-spinner small v-if="isLoading" class="mr-2"></b-spinner>
            <span v-if="!isLoading">Download</span>
          </b-button>
        </div>
      </div>

      <div class="row no-gutters mb-4">
        <div class="col-md-9">
          <label>Filter Berdasarkan Tanggal :</label>
          <div class="form-inline">
            <input name="start_date" type="text" onfocus="(this.type='date')" placeholder="Mulai Dari"
              class="form-control mr-2">
            <input name="end_date" type="text" onfocus="(this.type='date')" placeholder="Sampai Dengan"
              class="form-control mr-2">
            <b-button    class="btn btn-custom rounded-5 btn-sm" @click="applyDateFilter">Filter</b-button>
          </div>
        </div>
        <!-- <div class="col-md-3">
          <label>Filter By Date:</label>
          <div class="d-flex">
            <b-form-input v-model="filter" type="search" placeholder="Ketik untuk mencari .."></b-form-input>
            <b-button :disabled="!filter" @click="resetFilter" class="btn btn-primary btn-sm ml-2">Reset</b-button>
          </div>
        </div> -->
      </div>

      <div class="overflow-auto">
        <b-table id="pengajuan-table" responsive="true" :items="pengajuanItems" :fields="pengajuanFields"
          :current-page="currentPagePengajuan" :per-page="perPagePengajuan">
          <template v-slot:cell(id_transaksi)="data">
            <div>{{ data.item.id }}</div>
          </template>
          <template v-slot:cell(product)="data">
            <div>{{ data.item.product.nama_produk }}</div>
          </template>
          <template v-slot:cell(funder)="data">
            <div>{{ data.item.funder.name }}</div>
          </template>
          <template v-slot:cell(is_apuppt)="data">
            <div :style="{ color: data.item.setoran_awal > 500000000 ? 'red' : 'green' }">
              {{ data.item.setoran_awal > 500000000 ? 'Ya' : 'Tidak' }}
            </div>
          </template>
          <template v-slot:cell(pengajuan_disetujui_oleh)="data">
            <div>
              - {{ data.item.status_change_by ? (data.item.status_change_by.name ? data.item.status_change_by.name : '' ) : '' }}
              <br>
              - {{ data.item.status_utama_change_by ? (data.item.status_utama_change_by.name ? data.item.status_utama_change_by.name : '' ) : '' }}
            </div>
          </template>
          <template v-slot:cell(status_pengajuan)="data">
            <div
              :style="{
                color: data.item.status_pengajuan.code === 'PS04' ? 'orange' : 'green'
              }"
            >
              {{ data.item.status_pengajuan.name }}
            </div>
          </template>
          <template v-slot:cell(aksi)="data">
            <b-button @click="$router.push(`/show-pengajuan-lending/${data.item.funder.id}/${data.item.id}`)" type="button" 
              variant="primary" class="btn btn-custom theme-color rounded-5">
              Detail
            </b-button>
            <b-button v-if="data.item.status_pengajuan.code == 'PS04'" @click="changeStatus(data.item)" type="button"
              variant="success" class="btn btn-custom theme-color rounded-5 success">
              Setujui
            </b-button>
            <b-button v-if="data.item.status_pengajuan.code == 'PS04'" @click="rejectStatus(data.item)" type="button"
              variant="danger" class="btn btn-custom theme-color rounded-5 cancel">
              Tolak
            </b-button>
          </template>
        </b-table>
      </div>

      <b-modal size="md" v-model="confirmStatusModal" hide-footer hide-header>
        <div class="d-block text-center">
          <h3>{{ modalTitle }}</h3>
        </div>
        <b-form v-if="status_pengajuan_id == 3" @submit.prevent="handleSubmit()">
          <b-form-group>
            <label>Nomor Rekening Korespondensi<span class="text-danger"> *</span></label>
            <ValidationProvider name="nama bank" rules="required" v-slot="{ errors }">
              <b-form-select v-model="mitra_bank_id" required>
                <b-form-select-option disabled value="">Silakan pilih ...</b-form-select-option>
                <b-form-select-option v-for="option in bankOptions" :key="option.value" :value="option.value">
                  {{ option.text }}
                </b-form-select-option>
              </b-form-select>
              <span class="text-danger">{{ errors[ 0 ] }}</span>
            </ValidationProvider>
          </b-form-group>
        </b-form>
        <div v-if="!changingStatus" class="row">
          <div class="col">
            <b-button class="mt-3 btn-custom cancel"  block @click="confirmStatusModal = false">Tutup</b-button>
          </div>
          <div class="col" v-if="mitra_bank_id || status_pengajuan_id != 3">
            <b-button class="mt-3 btn-custom" block @click="confirmChangeStatus">Ya</b-button>
          </div>
        </div>
        <div v-else class="row">
          <div class="col text-center">
            <b-spinner variant="primary"></b-spinner>
          </div>
        </div>
      </b-modal>

      <h2 v-if="loaded == false" class="text-center"><b-spinner variant="warning"></b-spinner></h2>
      <b-pagination align="center" :total-rows="rowsPengajuan" :per-page="perPagePengajuan"
        aria-controls="pengajuan-table" v-model="currentPagePengajuan"></b-pagination>
    </div>

    <b-modal size="sm" v-model="successModal" hide-footer hide-header>
      <div class="d-block text-center">
        <b-icon icon="check-circle" animation="throb" variant="success" style="width: 120px; height: 120px;"></b-icon>
        <h3>Status berhasil diubah</h3>
      </div>
      <div class="row">
        <div class="col">
          <b-button class="mt-3" block @click="successModal = false">Tutup</b-button>
        </div>
      </div>
    </b-modal>
    
    <b-modal v-model="modalAuthSignUrl" title="Tanda Tangan Surat kuasa" hide-footer>
      <div class="text-center">
        <p>Silakan salin tautan URL yang tercantum di bawah ini, lalu serahkan kepada Direktur Utama agar beliau dapat mengakses dokumen terkait dan memberikan tanda tangan secara resmi pada Surat Kuasa yang telah disiapkan.</p>
        <b-form-input v-model="authSignUrl" readonly></b-form-input>
      </div>
      <div class="row">
        <div class="col">
          <b-button class="mt-3" variant="primary" block @click="copyToClipboard">Copy URL</b-button>
          <b-button class="mt-2" variant="danger" block @click="modalAuthSignUrl = false">Tutup</b-button>
        </div>
      </div>
    </b-modal>

    <b-modal size="md" v-model="emailNotificationModal" hide-footer hide-header>
      <div class="d-block text-center p-4">
        <b-icon icon="cloud-download" variant="primary" animation="spin" style="width: 80px; height: 80px;"></b-icon>
        <h3 class="mt-3">Permintaan Download Sedang Diproses</h3>
        <p class="mt-2">
          Data yang Anda minta sedang diproses dan akan segera tersedia. Link download akan dikirimkan ke email Anda
          dalam
          beberapa saat.
        </p>
        <p>Terima kasih atas kesabarannya!</p>
        <b-button class="mt-3" variant="primary" block @click="emailNotificationModal = false">Tutup</b-button>
      </div>
    </b-modal>

    <b-modal size="md" v-model="errorNotificationModal" hide-footer hide-header>
      <div class="d-block text-center p-4">
        <b-icon icon="exclamation-triangle-fill" variant="danger" style="width: 80px; height: 80px;"></b-icon>
        <h3 class="mt-3">Permintaan Download Gagal</h3>
        <p class="mt-2">
          Maaf, terjadi kesalahan saat memproses permintaan download Anda. Silakan coba lagi nanti atau hubungi tim
          dukungan
          jika masalah terus berlanjut.
        </p>
        <b-button class="mt-3" variant="danger" block @click="errorNotificationModal = false">Tutup</b-button>
      </div>
    </b-modal>

    <b-modal size="md" v-model="confirmRejectStatusModal">
      <div class="d-block text-center">
        <!-- Judul Modal -->
        <!-- <h3 class="font-weight-bold text-primary mb-3 mt-0">Konfirmasi Penolakan</h3>
        <p class="text-secondary mb-4">
          Anda akan menolak pengajuan ini. Silakan masukkan alasan penolakan di bawah ini.
        </p> -->
        <h3>{{ modalTitle }}</h3>
        <!-- <h4>{{ textModal }}</h4> -->
      </div>

      <template #modal-footer>
        <div v-if="changingStatus" class="text-center">
          <b-spinner variant="primary"></b-spinner>
        </div>
        <div v-else>
          <b-button @click="confirmRejectStatusModal = false" variant="danger">Tutup</b-button>
          <b-button @click="rejectStatusConfirm" variant="primary">Ya</b-button>
        </div>
      </template>
    </b-modal>

    <b-modal size="m" v-model="rejectModal">
      <div class="d-block text-center">
        <b-icon icon="check-circle" animation="throb" variant="success" style="width: 120px; height: 120px;"></b-icon>
        <h3>Pengajuan berhasil ditolak</h3>
      </div>
      <template #modal-footer>
        <div v-if="changingStatus" class="text-center">
          <b-spinner variant="primary"></b-spinner>
        </div>
        <div v-else>
          <b-button @click="rejectModal = false" variant="primary">Tutup</b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Pengajuan from '../../api/pengajuan.js';
import UserBank from '../../api/userbank.js';

const pengajuanFields = [
  { key: 'id_transaksi', label: 'ID Transaksi', sortable: false },
  { key: 'product', label: 'Nama Produk', sortable: true },
  { key: 'funder', label: 'Nama Nasabah', sortable: true },
  { key: 'product.sub_product_category.name', label: 'Kategori', sortable: true },
  { key: 'product.brands.name', label: 'Merk', sortable: true },
  { key: 'product.sub_brands.name', label: 'Sub Merk', sortable: true },
  { key: 'color_variant', label: 'Warna', sortable: true },
  { key: 'status_pengajuan', label: 'Status Pengajuan', sortable: true },
  { key: 'pengajuan_disetujui_oleh', label: 'Pengajuan Diperiksa Oleh', sortable: true },
  { key: 'aksi', label: 'Aksi' }
];

export default {
  name: "ManajemenPengajuanLending",
  data() {
    return {
      pengajuanItems: [],
      pengajuanFields: pengajuanFields,
      perPagePengajuan: 5,
      currentPagePengajuan: 1,
      confirmStatusModal: false,
      form_upload: {
        pengajuan_id: null,
        nomor_bilyet: '',
        upload_bilyet: null,
        nomor_resi: '',
        upload_resi: null,
      },
      successModal: false,
      modalTitle: '',
      textModal: '',
      modalDocTitle: '',
      changingStatus: false,
      loaded: false,
      mitra_bank_id: '',
      bankOptions: [], // Opsi bank yang tersedia
      isLoading: false,
      emailNotificationModal: false, // Control for the success email notification modal
      errorNotificationModal: false,  // Control for the error notification modal
      status_pengajuan_id: null,
      pengajuan_id: null,
      confirmRejectStatusModal: false,
      rejectModal: false,
      authSignUrl: null,
      isLoadingSign: null,
      modalAuthSignUrl: false
    };
  },
  computed: {
    rowsPengajuan() {
      return this.pengajuanItems.length;
    }
  },
  mounted() {
    this.loadData();
    this.loadBankOptions(); // Memuat data bank saat komponen dimuat
  },
  methods: {
    loadData() {
      Pengajuan.pengajuanLendingMitra()
        .then(res => {
          this.pengajuanItems = res.data.data.sort((a, b) => {
            const statusA = a.status_pengajuan_id ? a.status_pengajuan_id : '';
            const statusB = b.status_pengajuan_id ? b.status_pengajuan_id : '';
            if (statusA == 3) return -1;
            if (statusB == 3) return 1;
            return 0;
          });
          this.loaded = true;
        })
        .catch(err => console.log(err));
    },
    loadBankOptions() {
      UserBank.index()
        .then(res => {
          this.bankOptions = res.data.data.data.map(bank => ({
            value: bank.id,
            text: bank.bank.name + ' - ' + bank.account_name
          }));
        })
        .catch(err => console.error('Error loading bank options:', err));
    },
    async urlMitraAuthSign(item) {
      this.isLoadingSign= item.id;
      try {
        const webviewUrl = await Pengajuan.getUrlMitraAuthSign({
          pengajuan_id: item.id,
        });
        if (webviewUrl.data.meta.code === 200) {
          this.authSignUrl = webviewUrl.data.data;
          this.modalAuthSignUrl = true;
        } else {
          this.showToast(
            webviewUrl.data.meta.message || "Gagal mengambil URL Surat Kuasa.",
            "Kesalahan",
            "danger"
          );
        }
      } catch (error) {
        console.log('Terjadi kesalahan mengambil URL Surat Kuasa.', error)
        this.showToast("Terjadi kesalahan mengambil URL Surat Kuasa.", "Kesalahan", "danger");
      } finally {
        this.isLoadingSign = null;
      }
    },
    changeStatus(item) {
      this.product_id = item.id;
      this.status_pengajuan_id = item.status_pengajuan_id;
      this.modalTitle = 'Apa anda yakin ingin menyetujui pengajuan ini?';
      this.confirmStatusModal = true;
    },
    confirmChangeStatus() {
      this.changingStatus = true;
      const data = {
        id: this.product_id,
        mitra_bank_id: this.mitra_bank_id, // Menambahkan bank_id ke data yang dikirim
      };
      Pengajuan.approvePengajuanByMitraUtama(this.product_id)
        .then(res => {
          if (res.data.meta.code === 200) {
            this.confirmStatusModal = false;
            this.successModal = true;
            this.loadData();
          }
          this.changingStatus = false;
        })
        .catch(err => {
          console.log(err);
          this.changingStatus = false;
        });
    },
    applyDateFilter() {
      return;
    },
    convertStatusPembayaran(status) {
      switch (status) {
        case 'pending':
          return 'Menunggu Konfirmasi Mitra';
        case 'approved':
          return 'Disetujui Mitra';
        case 'rejected':
          return 'Ditolak Mitra';
        default:
          return '';
      }
    },
    downloadPengajuanMitra() {
      this.isLoading = true;
      Pengajuan.downloadPengajuanMitra()
        .then((response) => {
          if (response.data.meta.code === 200) {
            this.emailNotificationModal = true; // Show the email notification modal
          } else {
            this.errorNotificationModal = true; // Show the error notification modal for non-200 responses
          }
        })
        .catch((error) => {
          console.error('Error downloading the file:', error);
          this.errorNotificationModal = true; // Show the error notification modal for request failures
        }).finally(() => {
          this.isLoading = false;
        });
    },
    convertStatusDocument(status) {
      switch (status) {
        case 'mitra_uploaded':
              return 'Dikirim Mitra';
          case 'funder_received':
              return 'Diterima Nasabah';
          case 'funder_uploaded':
              return 'Dikirim Nasabah';
          case 'mitra_received':
              return 'Diterima Mitra'
          default:
              return '';
      }
    },
    rejectStatus(item) {
      this.pengajuan_id = item.id;
      this.modalTitle = 'Apakah anda yakin akan menolak pengajuan ini ?';
      // this.textModal = 'Anda akan menolak pengajuan ini ?';
      this.confirmRejectStatusModal = true;
    },
    rejectStatusConfirm() {
      this.changingStatus = true;
      Pengajuan.utamaRejectStatus(this.pengajuan_id)
        .then(res => {
          if (res.data.meta.code === 200) {
            this.confirmRejectStatusModal = false;
            this.rejectModal = true;
            this.loadData();
          } else {
            console.log(res.data);
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.changingStatus = false;
        });
    },
    copyToClipboard() {
      navigator.clipboard.writeText(this.authSignUrl)
        .then(() => {
          this.showToast("URL berhasil disalin!", "Sukses", "success");
        })
        .catch(() => {
          this.showToast("Gagal menyalin URL.", "Kesalahan", "danger");
        });
    },
    showToast(message, title, variant = "default") {
      this.$bvToast.toast(message, {
        title: title,
        variant: variant,
        solid: true,
        autoHideDelay: 5000,
      });
    },
  },
};
</script>

<style scoped>
.overflow-auto {
  overflow-x: auto;
  /* Mengaktifkan scroll horizontal */
  white-space: nowrap;
  /* Mencegah pembungkusan teks */
}

.b-table {
  min-width: 800px;
  /* Sesuaikan dengan lebar minimal yang Anda inginkan */
}
.btn-custom {
  background-color: #f6bc3c;
  color: #274c8f;
  border-radius: 5px;
}
.btn-custom:hover {
  background-color: #274c8f;
  color: #ffffff;
}
.cancel:hover {
  background-color: #fd0000;
  color: #ffffff;
}
.success:hover {
  background-color: #00b300;
  color: #ffffff;
}
.btn-disabled {
  background-color: #d5a031  !important;
  color: #ffffff !important;
  opacity: 1; /* Hilangkan efek transparan */
  cursor: not-allowed; /* Tetap tidak interaktif */
  pointer-events: none; /* Tidak bisa diklik */
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/manajemen-pengajuan-lending.vue